<template>
  <div class="container mb-4">
    <div class="loading" v-if="loading">Loading&#8230;</div>

    <div class="view-header my-4 oculto-impresion">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Reporte Z</h1>
          <p class="view-header__subtitle">Cierre Z por punto de venta: ventas, neto, IVA por alícuota y percepciones.</p>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel oculto-impresion">
      <div class="filters-panel__row">
        <div class="filters-panel__field">
          <label class="control-label">Punto de venta</label>
          <q-select v-model="selectedPos" :options="posOptions" placeholder="- Seleccione punto de venta -" />
        </div>
        <div class="filters-panel__actions">
          <button
            type="button"
            class="filters-panel__btn filters-panel__btn--primary"
            :disabled="selectedPos == null"
            @click="getReport()"
          >
            <i class="bi bi-file-earmark-bar-graph"></i>
            Generar reporte
          </button>
          <button
            type="button"
            class="filters-panel__btn filters-panel__btn--outline"
            :disabled="report == null"
            @click="printReport()"
          >
            <i class="bi bi-printer"></i>
            Imprimir
          </button>
        </div>
      </div>
    </div>

    <!-- TICKET -->
    <div v-if="report != null" class="z-ticket-wrap">
      <div class="z-ticket">
        <div class="z-ticket__head">
          <div class="z-ticket__title">REPORTE Z</div>
          <div class="z-ticket__company">{{ report.company }}</div>
          <div class="z-ticket__meta">Generado: {{ report.date }} · {{ report.time }}</div>
          <div class="z-ticket__meta">Punto de venta: {{ report.pos }}</div>
        </div>

        <div class="z-ticket__section">
          <div class="z-ticket__row">
            <span>Ventas Total</span><span>$ {{ report.FCtotal }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Ventas Neto</span><span>$ {{ report.FCneto }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Ventas IVA</span><span>$ {{ report.FCiva }}</span>
          </div>
          <div v-if="report.FCiva25 > 0" class="z-ticket__row z-ticket__row--sub">
            <span>IVA 2.5%</span><span>$ {{ report.FCiva25 }}</span>
          </div>
          <div v-if="report.FCiva5 > 0" class="z-ticket__row z-ticket__row--sub">
            <span>IVA 5%</span><span>$ {{ report.FCiva5 }}</span>
          </div>
          <div v-if="report.FCiva105 > 0" class="z-ticket__row z-ticket__row--sub">
            <span>IVA 10.5%</span><span>$ {{ report.FCiva105 }}</span>
          </div>
          <div v-if="report.FCiva21 > 0" class="z-ticket__row z-ticket__row--sub">
            <span>IVA 21%</span><span>$ {{ report.FCiva21 }}</span>
          </div>
          <div v-if="report.FCiva27 > 0" class="z-ticket__row z-ticket__row--sub">
            <span>IVA 27%</span><span>$ {{ report.FCiva27 }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Percepciones</span><span>$ {{ report.FCpercep }}</span>
          </div>
        </div>

        <div class="z-ticket__section">
          <div class="z-ticket__row">
            <span>N. Crédito Total</span><span>$ {{ report.NCtotal }}</span>
          </div>
          <div class="z-ticket__row">
            <span>N. Crédito Neto</span><span>$ {{ report.NCneto }}</span>
          </div>
          <div class="z-ticket__row">
            <span>N. Crédito IVA</span><span>$ {{ report.NCiva }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Percepciones</span><span>$ {{ report.NCpercep }}</span>
          </div>
        </div>

        <div class="z-ticket__section">
          <div class="z-ticket__row">
            <span>Última Venta A</span><span>{{ report.FClastA }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Última Venta B</span><span>{{ report.FClastB }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Última N. Crédito A</span><span>{{ report.NClastA }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Última N. Crédito B</span><span>{{ report.NClastB }}</span>
          </div>
        </div>

        <div class="z-ticket__section">
          <div class="z-ticket__row">
            <span>Facturas emitidas</span><span>{{ report.FCcount }}</span>
          </div>
          <div class="z-ticket__row">
            <span>N. Crédito emitidas</span><span>{{ report.NCcount }}</span>
          </div>
          <div class="z-ticket__row">
            <span>Comprobantes con CAE</span><span>{{ report.CAEcount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: { QSelect },
  data: function () {
    return {
      loading: false,
      report: null,
      selectedPos: null,
      posList: [],
    };
  },
  computed: {
    posOptions() {
      return this.posList.map(pos => ({ value: pos.id, label: `${pos.branchoffice.name} - ${pos.number}` }));
    },
  },
  mounted() {
    this.loadSalepoints();
  },
  methods: {
    loadSalepoints() {
      let vm = this;
      axios.get(process.env.VUE_APP_BASE_URL + '/api/configs/pos/list')
        .then((response) => {
          if (response.data.success) {
            vm.posList = response.data.data;
          }
        })
        .catch((error) => {
          console.log('error: ' + error);
        });
    },
    getReport() {
      let vm = this;
      vm.loading = true;
      axios.get(process.env.VUE_APP_BASE_URL + '/api/reports/reportZ/' + vm.selectedPos)
        .then((response) => {
          if (response.data.success) {
            vm.report = response.data.data;
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.loading = false;
          alert(error);
        });
    },
    printReport() {
      // Imprime el ticket que ya está en pantalla (como los comprobantes):
      // el @media print oculta header/filtros y deja solo el .z-ticket.
      window.print();
    },
  },
};
</script>

<style scoped>
/* El campo lleva label encima (empuja el select hacia abajo); alineamos los
   botones al fondo del row para que queden a la misma altura que el select. */
.filters-panel__actions {
  align-self: flex-end;
}

.z-ticket-wrap {
  display: flex;
  justify-content: center;
}

.z-ticket {
  width: 100%;
  max-width: 360px;
  background: var(--surface);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  padding: 20px 24px;
  color: var(--text);
  font-size: 13px;
}

.z-ticket__head {
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px dashed var(--border);
}

.z-ticket__title {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 6px;
}

.z-ticket__company {
  font-weight: 600;
}

.z-ticket__meta {
  font-size: 12px;
  color: var(--text-muted);
}

.z-ticket__section {
  padding: 14px 0;
  border-bottom: 1px dashed var(--border);
}

.z-ticket__section:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.z-ticket__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  line-height: 1.7;
}

.z-ticket__row > span:last-child {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.z-ticket__row--sub {
  color: var(--text-soft);
  padding-left: 14px;
  font-size: 12px;
}

@media print {
  /* Oculta header, filtros y botones: solo se imprime el ticket. */
  .oculto-impresion {
    display: none !important;
  }

  /* El ticket se imprime arriba a la izquierda (no centrado). */
  .z-ticket-wrap {
    display: block;
  }

  /* En papel el ticket es blanco a sangre, sin sombra ni borde decorativo
     (y así también sale legible si se imprime desde dark mode). */
  .z-ticket {
    width: 58mm;
    max-width: 58mm;
    margin: 10px 0 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    background: #fff;
    color: #000;
  }

  .z-ticket__head,
  .z-ticket__section {
    border-color: #000;
  }

  .z-ticket__meta,
  .z-ticket__row--sub {
    color: #000;
  }
}
</style>
